let YOUTUBE_API_KEY = 'AIzaSyBke2rzMLME-I6POOGYgGFzQZR2U6pYmjc';
export default YOUTUBE_API_KEY;


/** WEBPACK FOOTER **
 ** ./src/core/services/constants.js
 **/